<div class="card-container">
    <i-feather class="icon" name="{{iconName}}"></i-feather>
    <div class="title">{{title}}</div>
</div>